import { render, staticRenderFns } from "./HomeDesktop.vue?vue&type=template&id=d1ed3b28&scoped=true&"
import script from "./HomeDesktop.vue?vue&type=script&lang=js&"
export * from "./HomeDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ed3b28",
  null
  
)

export default component.exports